import * as actionTypes from "./constants";

export const setDates = (dateFrom, dateTo) => ({
  type: actionTypes.SET_DATES,
  dateFrom,
  dateTo
});

export const setFocusedInput = input => ({
  type: actionTypes.SET_FOCUSED_INPUT,
  input
});



// WEBPACK FOOTER //
// ./src/cleaning/schedule/dateRangePicker/actions.js